<template>
  <div class="section-score-field-response">
    <div class="field-header">
      <h3 class="field-label">
        {{ field.label }}
        <v-chip x-small color="info" class="ml-2">Auto-calculated</v-chip>
      </h3>
    </div>

    <div v-if="field.description" class="field-description">
      {{ field.description }}
    </div>

    <v-text-field
      :value="displayValue"
      outlined
      dense
      disabled
      readonly
      type="number"
      class="readonly-input"
      :hint="field.scoreSection ? `Score from: ${field.scoreSection.name}` : ''"
      persistent-hint
    ></v-text-field>
  </div>
</template>

<script>
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component
export default class SectionScoreFieldResponse extends Vue {
  @Prop({ type: Object, required: true }) field;
  @Prop({ type: Object, required: false }) response;
  @Prop({ type: Boolean, required: false }) disabled;

  localResponse = {
    fieldId: 0,
    numericValue: null,
    comment: ''
  };

  get displayValue() {
    return this.localResponse.numericValue != null ? this.localResponse.numericValue : 0;
  }

  created() {
    this.initializeResponse();
  }

  @Watch('response')
  onResponseChange() {
    this.initializeResponse();
  }

  initializeResponse() {
    if (this.response) {
      this.localResponse = { ...this.response };
    } else {
      this.localResponse = {
        fieldId: this.field.id || 0,
        numericValue: null,
        comment: ''
      };
    }
  }
}
</script>

<style scoped>
.section-score-field-response {
  width: 100%;
}

.field-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 8px;
}

.field-label {
  font-size: 1rem;
  font-weight: 500;
  color: #333;
  margin: 0 0 4px 0;
  display: flex;
  align-items: center;
}

.field-description {
  font-size: 0.85rem;
  color: rgba(0, 0, 0, 0.6);
  margin-bottom: 12px;
}

.readonly-input :deep(.v-input__slot) {
  background-color: #f5f5f5 !important;
}
</style>
